module.exports = __webpack_public_path__ + "static/media/2.9c401ed.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/2.mp4
// module id = Qhlf
// module chunks = 1